module.exports = __webpack_public_path__ + "media/stylesheets/images/logo-19c86a08ded892795fd8623237e2a398.svg";